import React, { memo, useMemo, useCallback } from "react"

import { useApp } from "../../../hooks/useApp"
import { usePage } from "../../../hooks/usePage"
import { useCustomerLogout } from "../../../hooks/useCustomer"

export const withAccountLogout = Component =>
  memo(({ name = "AccountLogout" }: any) => {
    const { logoutCustomer } = useCustomerLogout()
    const { globalStateReducer } = useApp()
    const {
      dashboard: { additionalLogoutButton },
    } = usePage()

    const [{ activeAccount }, dispatch] = globalStateReducer

    const handleLogout = useCallback(() => {
      if (activeAccount) {
        dispatch({
          type: "setActiveAccount",
          payload: !activeAccount,
        })
      }
      logoutCustomer()
    }, [activeAccount, dispatch, logoutCustomer])

    Component.displayName = name
    return useMemo(() => <Component handleLogout={() => handleLogout()} additionalLogoutButton={additionalLogoutButton} />, [
      handleLogout,
      additionalLogoutButton,
    ])
  })
